import graphql__8d2b89c153e5dac32542 from "./__generated__/SubscribeToEventButton_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import ButtonLink from "../Buttons/ButtonLink";
import { useRoutesContext } from "../Routes/RoutesContext";
import { useFormatMessageWithCustomization } from "../Intl/Context";
import { isUnauthorized } from "../Utils/authorizations";

const SubscribeToEventButton = props => {
  const participativeModule = useFragment(
    SubscribeToEventButton_participativeModule,
    props.participativeModule
  );
  const { slug: participativeModuleSlug } = participativeModule;
  const { contributionsSubmissionAuthorized } = participativeModule.authorizations;
  const { className } = props;

  const translateWithCustomization = useFormatMessageWithCustomization(
    participativeModule.visualization.customIntlMessages
  );
  const contributionFormButtonLabel = translateWithCustomization(
    intlMessages.contributionForm
  );

  const { pathFor } = useRoutesContext();
  const contributionFormPath = pathFor("newContribution", {
    participativeModuleSlug
  });

  // Only render contribution form submission link if the step authorizes users
  // to do so.
  //
  // If the user already submitted a contribution for the current call for
  // contributions, we show the button but disable it.
  //
  if (isUnauthorized(contributionsSubmissionAuthorized)) return null;

  return (
    <ButtonLink
      href={contributionFormPath}
      className={className}
      label={contributionFormButtonLabel}
      iconClassName="icon-contribute"
      iconPosition="after"
    />
  );
};

const SubscribeToEventButton_participativeModule = graphql__8d2b89c153e5dac32542;

export default SubscribeToEventButton;

const intlMessages = defineMessages({
  contributionForm: {
    id: "event.subscribe",
    defaultMessage: "S'inscrire à l'évènement",
    description: "Libellé du bouton d'inscription à l'évènement"
  }
});
